import { IGroup } from "@nju/data-access-portal-dashboard";
import { IMultiOrderOrchestrator } from "@nju/data-access-portal-orchestrator";

interface IResolveShowAddNumberButtonProps {
  groups: IGroup[];
  multiOrderOrchestrator: IMultiOrderOrchestrator | undefined;
  currentOfferCategory: IGroup["members"][number]["offerCategory"];
}

export function resolveShowAddNumberButton({
  multiOrderOrchestrator,
  groups,
  currentOfferCategory,
}: IResolveShowAddNumberButtonProps) {
  //W przypadku gdy nie mamy jeszcze wybranej ilości numerów multiOrderItemsCount nie przyjdzie z API dlatego w takim przypadku podstawiamy 0
  const numberOfMultiOrderNumbers =
    multiOrderOrchestrator?.multiOrderItemsCount || 0;
  const groupCapacityDetails = groups[0]?.metadata?.capacityDetails?.find(
    ({ offerCategory }) => {
      return offerCategory === currentOfferCategory;
    },
  );
  const groupCapacity =
    groupCapacityDetails?.capacity || groups[0]?.metadata?.capacity;
  const orchestratorCapacityDetails =
    multiOrderOrchestrator?.capacityDetails?.find(({ offerCategory }) => {
      return offerCategory === currentOfferCategory;
    });
  const orchestratorCapacity =
    orchestratorCapacityDetails?.capacity ||
    multiOrderOrchestrator?.groupCapacity;

  if (!multiOrderOrchestrator && !!(groupCapacity && groupCapacity > 0)) {
    return true;
  }

  if (
    multiOrderOrchestrator &&
    !!(
      orchestratorCapacity &&
      orchestratorCapacity - numberOfMultiOrderNumbers !== 0
    )
  ) {
    return true;
  }

  return false;
}
